import axios from "axios";
import { validateEmail50, validateSomething } from "../../Form/Validations";
import { toast } from "react-toastify";


export class Ceres {
    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data) {
        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const selected = props.dialogState.data.farms.find(e => values.ceresId === e.future_id);
                const body = {
                    tipo: "CERES",
                    farms: [
                        {
                            campo_id: parseInt(props.farmId, 10),
                            ceres_id: selected?.future_id,
                            customerCeresId: selected?.customer_id
                        }
                    ],
                    refresh_token: props.dialogState.data.refreshToken,
                    user_name: props.dialogState.data.username
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("external.login"),
                    validateFunction: this.validateLogin,
                    inputs: [
                        {
                            label: t("external.username"),
                            campo: "username",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            useCampo2: true,
                            label: t("external.password"),
                            campo: "password",
                            validation: validateSomething,
                            component: "text",
                            eyeForPassword: true,
                            type: "password"
                        },
                    ],
                },
                {
                    label: t("external.conectar"),
                    inputs: [
                        {
                            label: t("external.choose"),
                            campo: "ceresId",
                            validation: validateSomething,
                            component: "select",
                            optionsName: "farms",
                            optionLabel: "name",
                            optionKey: "future_id",
                        }
                    ]
                },
            ],
        };
    }

    static async validateLogin(values, props) {
        const isSubmitting = props.innerRef.current.isSubmitting;
        const errors = {};
        try {
            if (values) {
                const erUser = validateEmail50(values.username);
                if (erUser !== undefined) errors.username = erUser;

                const erPass = validateSomething(values.password);
                if (erPass !== undefined) errors.password = erPass;

                if(errors.password || errors.username) return errors;

                if (isSubmitting){
                    props.setForceLoading(true);
                    /**
                   * @returns {{ access: string, refresh: string }}
                  */
                    const getAccessRefreshToken = async () => {
                        const body = { username: values.username, password: values.password };
                        const { data } = await axios.post("https://works.ceresimaging.net/api/token/", body);
                        return data;
                    };
                    const tokenResponse = await getAccessRefreshToken();

                    await new Promise(resolve => setTimeout(resolve, 100));

                    if (tokenResponse?.access) {
                        const customConfig = {
                            headers: {
                                Authorization: `Bearer ${tokenResponse.access}`,
                            }
                        };
                        /**
                       * @type {{ data: { farms: any[] }}}
                       */
                        const { data } = await axios.get("https://works.ceresimaging.net/api/cff/", customConfig);

                        // set data that it will be used in the next step of the form
                        props.setDialogState(s => ({
                            ...s,
                            data: {
                                farms: data?.farms,
                                username: values.username,
                                refreshToken: tokenResponse?.refresh
                            }
                        }));
                    } else throw new Error("");

                    props.setForceLoading(false);
                }
                return errors;
            }
        } catch (error) {
            if (error.response?.data?.badCredentials){
                errors.unknown = props.t("forms.toast401");
                toast.error(props.t("forms.toast401"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
            } else {
                errors.unknown = props.t("external.error-sign-in");
                toast.error(props.t("external.error-sign-in"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
            }
            props.setForceLoading(false);
            return errors;
        }
    }
}
